export interface ColumnProps {
    label: string;
    prop: string;
    /** 固定宽度：100 | '20%' */
    width?: number | string;

    /** 最小宽度：80 | '15%' */
    minWidth?: number | string;
    align?: "left" | "center" | "right";
    slot?: string;
    format?: (value: any, row: Record<string, any>, index: number) => string;
}

export enum NUMS {
    ONE = 1,
    TWO = 2,
    THREE = 3,
}

export type MessageQueueExpose = {
    // 开始播报
    enableSpeech: () => void;
    // 停止播报
    stopSpeech: () => void;
};

export const numOptions = [
    { label: "1次", value: NUMS.ONE },
    { label: "2次", value: NUMS.TWO },
    { label: "3次", value: NUMS.THREE },
]

export function toPx(value: number | string, base: number) {
    if (typeof value === "number") return value;
    if (value.endsWith("%")) {
        return (parseFloat(value) / 100) * base;
    }
    return parseFloat(value);
}

export function getValueByPath(obj: any, path: string) {
    if (!obj || !path) return null;

    const result = path.split('.').reduce((acc, key) => {
        if (acc == null) return null; // 包含 null / undefined
        return acc[key];
    }, obj);

    return result ?? null;
}

/**
 * 将总秒数转换为 分钟 和 秒
 * @param totalSeconds - 总秒数
 * @returns { seconds: number, minutes: number }
 */
export function formatSecondsToMinuteSecond(totalSeconds: number): string {
    // 向下取整得到分钟
    const minutes = Math.floor(totalSeconds / 60);

    // 取余得到剩余的秒
    const seconds = totalSeconds % 60;

    if (minutes) {
        return `${minutes}m${seconds}s`
    }

    return `${seconds}s`
}